import { render, staticRenderFns } from "./zytlxc.vue?vue&type=template&id=763dae66&scoped=true"
import script from "./zytlxc.vue?vue&type=script&lang=js"
export * from "./zytlxc.vue?vue&type=script&lang=js"
import style0 from "./zytlxc.vue?vue&type=style&index=0&id=763dae66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763dae66",
  null
  
)

export default component.exports